<template>
  <div id="Koszyk">
    <div style="width:1240px; margin:0px auto;position: relative">
      <div id="koszyk-panel">
        <div id="img">
          <img src="../assets/cart.png" alt="" width="40" height="30">
        </div>
        <div id="netto">
          <span style="width:100%;display: block;font-size: 11px;">{{$t('message.cena_detal')}}</span>
          <span style="font-weight: bold; color:white">{{Number(cenaDetal[0] + cenaDetal[1]).toFixed(2)}} {{$t('message.zl')}}</span>
        </div>
        <div id="rabat" v-if="inputs.rabatCB">
          <span style="width:100%;display: block;font-size: 11px;">{{$t('message.rabat')}} <b style="font-size:14px">{{inputs.rabatValue}}%</b></span>
          <span style="font-weight: bold; color:white">{{cenaRabat.toFixed(2)}} {{$t('message.zl')}}</span>
        </div>
      </div>

    <!-- <div class="form-group" style="margin-bottom:4px;text-align: right;float: right;width: 130px; position: absolute; top:10px; right:16px; color:white">

      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-sort-down-alt" viewBox="0 0 16 16">
        <path d="M3.5 3.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 12.293V3.5zm4 .5a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1h-1zm0 3a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1h-3zm0 3a.5.5 0 0 1 0-1h5a.5.5 0 0 1 0 1h-5zM7 12.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5z"/>
      </svg>

       <select :disabled="Object.keys(outputs.szafa).length === 0" class="activity-overview__select" @change="zmianaSortowania()" v-model="selectSort" style="padding: 4px;">
        <option value="symbol">symbol</option>
        <option value="nazwa">nazwa</option>
      </select>
    </div> -->

    <!-- <div class="form-group" style="margin-bottom:4px;text-align: right;float: right;width: 210px; position: absolute; top:12px; right:150px; color:white">

          <div class="topnav" style="float:left;top: -3px;">
        <div class="search-container">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16"
              style="padding: 3px;border-radius: 0px;float: left;top: 0px;left: -4px;position: relative;">
              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
            </svg>
          <form v-on:keydown.13.capture.prevent.stop autocomplete="off" style="width: 270px;">
            <input :disabled="Object.keys(outputs.szafa).length === 0" class="form-control form-control-sm" type="text" :placeholder="$t('message.wyszukaj_produkt')" name="search"
              v-model="searching" @input="search_product">
          </form>
        </div>

        <transition name="fade">
        <div id="productsList" v-if="SearchProduct.length > 0">
          <ul class="list-group">
            <li class="list-group-item" v-for="(item, index) in SearchProduct" :key="index">
              <button @click="wybranie_akcesorium_search(item)">{{item.symbol}} - {{item.nazwa}}</button></li>
          </ul>
        </div>
        </transition>
      </div>

    </div> -->

      <!-- <div class="form-group" style="margin-bottom:4px;text-align: right;float: right;width: 200px; position: absolute;">sortowanie -->
        <!-- <button :disabled="Object.keys(outputs.szafa).length === 0" class="btn btn-info" @click="sortowanie('symbol')" :class="{active: activeSort === 'symbol'}">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-sort-numeric-down" viewBox="0 0 16 16">
            <path d="M12.438 1.668V7H11.39V2.684h-.051l-1.211.859v-.969l1.262-.906h1.046z"/>
            <path fill-rule="evenodd" d="M11.36 14.098c-1.137 0-1.708-.657-1.762-1.278h1.004c.058.223.343.45.773.45.824 0 1.164-.829 1.133-1.856h-.059c-.148.39-.57.742-1.261.742-.91 0-1.72-.613-1.72-1.758 0-1.148.848-1.835 1.973-1.835 1.09 0 2.063.636 2.063 2.687 0 1.867-.723 2.848-2.145 2.848zm.062-2.735c.504 0 .933-.336.933-.972 0-.633-.398-1.008-.94-1.008-.52 0-.927.375-.927 1 0 .64.418.98.934.98z"/>
            <path d="M4.5 2.5a.5.5 0 0 0-1 0v9.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L4.5 12.293V2.5z"/>
          </svg>
        </button>

        <button :disabled="Object.keys(outputs.szafa).length === 0" class="btn btn-info" @click="sortowanie('nazwa')" :class="{active: activeSort === 'nazwa'}">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-sort-alpha-down" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M10.082 5.629L9.664 7H8.598l1.789-5.332h1.234L13.402 7h-1.12l-.419-1.371h-1.781zm1.57-.785L11 2.687h-.047l-.652 2.157h1.351z"/>
            <path d="M12.96 14H9.028v-.691l2.579-3.72v-.054H9.098v-.867h3.785v.691l-2.567 3.72v.054h2.645V14zM4.5 2.5a.5.5 0 0 0-1 0v9.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L4.5 12.293V2.5z"/>
          </svg>
        </button> -->
      <!-- </div> -->

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { app } from '../mixins/app'

export default {
  name: 'Koszyk',
  mixins: [app],
  data () {
    return {
      // activeSort: 'symbol',
      // selectSort: 'symbol',
      // searching: '',
      // listSearchProduct: []
    }
  },
  computed: {
    ...mapGetters('app', ['inputs', 'outputs']),
    ...mapGetters('products', ['ListaSzafy', 'ListaAkcesoria']),
    cenaRabat () {
      return (Number(this.cenaDetal[0]) - Number(this.cenaDetal[0]) * (Number(this.inputs.rabatValue) / 100)) + Number(this.cenaDetal[1])
    },
    cenaDetal () {
      var cenaSzafa = 0
      var cenaPrzodStop = 0
      var cenaPrzod = 0
      var cenaTylStop = 0
      var cenaTyl = 0
      var cenaInneStop = 0
      var cenaInne = 0
      var sumaPodzespolyStop = 0
      var sumaPodzespoly = 0
      var sumaStop = 0
      var suma = 0

      if (!this.inputs.sameAkcesoria) {
        if (this.outputs.szafa.cena) {
          cenaSzafa = Number(this.outputs.szafa.cena)
        }
      }
      // console.log(this.outputs.items_przod)
      this.outputs.items_przod.forEach(element => {
        if (element.wyprzedaz) {
          cenaPrzodStop += Number(element.cena)
        } else {
          cenaPrzod += Number(element.cena)
        }
      })
      // console.log('cenaPrzod', cenaPrzod)
      this.outputs.items_tyl.forEach(element => {
        if (element.wyprzedaz) {
          cenaTylStop += Number(element.cena)
        } else {
          cenaTyl += Number(element.cena)
        }
      })
      this.outputs.items_inne.forEach(element => {
        if (element.wyprzedaz) {
          cenaInneStop += (Number(element.cena) * Number(element.value))
        } else {
          cenaInne += (Number(element.cena) * Number(element.value))
        }
      })

      Object.keys(this.outputs.podzespoly).forEach(element => {
        if (this.outputs.podzespoly[element] !== null) {
          Object.keys(this.outputs.podzespoly[element]).forEach(item => {
            if (this.outputs.podzespoly[element][item].value > 0) {
              if (this.outputs.podzespoly[element][item].wyprzedaz) {
                sumaPodzespolyStop += (this.outputs.podzespoly[element][item].value * this.outputs.podzespoly[element][item].cena)
              } else {
                sumaPodzespoly += (this.outputs.podzespoly[element][item].value * this.outputs.podzespoly[element][item].cena)
              }
            }
          })
        }
      })

      sumaStop = (cenaPrzodStop + cenaTylStop + cenaInneStop + sumaPodzespolyStop)
      suma = (cenaSzafa + cenaPrzod + cenaTyl + cenaInne + sumaPodzespoly)

      if (suma === 0) {
        return [0, 0]
      }
      return [suma, sumaStop]
    }
    // SearchProduct () {
    //   return this.listSearchProduct
    // }
  },
  methods: {
    // sortowanie (val) {
    //   if (this.activeSort === val) {

    //   } else {
    //     this.activeSort = val
    //     if (this.outputs.szafa.value && this.outputs.szafa.wysokosc_montazowa) {
    //       this.get_akcesoria(this.outputs.szafa.value, this.outputs.szafa.wysokosc_montazowa, val)
    //     }
    //   }
    // },
    // get_akcesoria (kod, wysokosc, sort) {
    //   this.$store.dispatch('products/load_list_akcesoria', [kod, wysokosc, sort, this.$i18n.locale])
    //   // console.log(this.produkty_akcesoria)
    // },
    // zmianaSortowania () {
    //   this.sortowanie(this.selectSort)
    // },
    // search_product () {
    //   if (event.keyCode === 13) {
    //   } else {
    //     this.listSearchProduct = []
    //     if (this.searching.length > 2) {
    //       this.ListaAkcesoria.akcesoria.filter((item) => {
    //       // console.log(item.symbol.startsWith(this.searching))
    //         if (item.symbol.toLowerCase().includes(this.searching.toLowerCase()) || item.nazwa.toLowerCase().includes(this.searching.toLowerCase())) {
    //           item.grupa = 'pozostale'
    //           this.listSearchProduct.push(item)
    //         }
    //       })
    //     }
    //     if (this.searching.length > 2) {
    //       this.ListaAkcesoria.obudowy.filter((item) => {
    //       // console.log(item.symbol.startsWith(this.searching))
    //         if (item.symbol.toLowerCase().includes(this.searching.toLowerCase()) || item.nazwa.toLowerCase().includes(this.searching.toLowerCase())) {
    //           item.grupa = 'obudowy'
    //           this.listSearchProduct.push(item)
    //         }
    //       })
    //     }
    //     if (this.searching.length > 2) {
    //       this.ListaAkcesoria.zasilacze.filter((item) => {
    //       // console.log(item.symbol.startsWith(this.searching))
    //         if (item.symbol.toLowerCase().includes(this.searching.toLowerCase()) || item.nazwa.toLowerCase().includes(this.searching.toLowerCase())) {
    //           item.grupa = 'zasilacze'
    //           this.listSearchProduct.push(item)
    //         }
    //       })
    //     }
    //     if (this.searching.length > 2) {
    //       this.ListaAkcesoria.switche.filter((item) => {
    //       // console.log(item.symbol.startsWith(this.searching))
    //         if (item.symbol.toLowerCase().includes(this.searching.toLowerCase()) || item.nazwa.toLowerCase().includes(this.searching.toLowerCase())) {
    //           item.grupa = 'switche'
    //           this.listSearchProduct.push(item)
    //         }
    //       })
    //     }
    //     this.listSearchProduct.sort()
    //   }
    // },
    // wybranie_akcesorium_search (item) {
    //   this.searching = ''
    //   this.search_product()
    //   this.wybranie_akcesorium(item)
    // },
    // wybranie_akcesorium (item) {
    //   // console.log(grupa, item)
    //   this.clearViewAkcesorium = false
    //   if (Object.keys(item).length > 0) {
    //     this.$store.commit('app/ADD_ITEM', item)
    //     // this.$store.commit('app/ADD_ITEMS', ['przod', selected])
    //   }
    //   this.selectedAkcesoria = item
    // }
  }
}
</script>

<style scoped>
#Koszyk{
  /* height: 45px;
  position: absolute;
  z-index: 4;
  left: calc(50vw - 394px); */
  height: 45px;
  position: relative;
  z-index: 4;
  width: 100%;
  background: #00c3ff;
}
#koszyk-panel {
  height: 45px;
  background: #00c3ff;
  position: relative;
  max-width: 320px;
}
#koszyk-panel #img {
  width: 50px;
  padding: 6px;
  text-align: left;
  float: left;
}
#koszyk-panel #netto {
  width: 115px;
  padding: 3px 8px;;
  float: left;
  display: block;
  text-align: right;
}
#koszyk-panel #rabat {
  width: 120px;
  padding: 3px 12px;;
  float: left;
  display: block;
  text-align: right;
  border-left: 3px inset rgb(64, 64, 64);
  height: 45px;
}
</style>



// WEBPACK FOOTER //
// src/components/Koszyk.vue